/* istanbul ignore file */
import React from 'react';

import { DelayedSuspense } from '@lumapps/lumx-suspense/components/DelayedSuspense';

import { CommunityPickerDialogProps } from '../../types';

const CommunityPickerDialogLazy = React.lazy(
    () =>
        import(
            /* webpackChunkName: 'community-picker-dialog' */
            './CommunityPickerDialog'
        ),
);

const CommunityPickerDialog: React.FC<CommunityPickerDialogProps> = (props) => {
    const { isOpen } = props;

    return (
        <DelayedSuspense isDialog shouldLoad={isOpen}>
            {(setShouldMount) => <CommunityPickerDialogLazy onVisibilityChange={setShouldMount} {...props} />}
        </DelayedSuspense>
    );
};

export { CommunityPickerDialog };
export type { CommunityPickerDialogProps };
